import React from 'react';
import PropTypes from 'prop-types';
import { ReviewGuestUpdateHV } from './host/ReviewGuestUpdateHV';
import { normalizedContractsShape, priceBreakdownObject } from '../app-bookings-request/forms/bookingUtil';
import ReviewGuestUpdateGV from './guest/ReviewGuestUpdateGV';
import CurrentDetailsContainer from '../app-main/containers/CurrentDetailsContainer';
import SharedIntlProviderHOC from 'shared-components/hocs/sharedIntlProviderHOC';

export class ReviewGuestUpdateMain extends React.Component {
  constructor (props) {
    super(props);

    this.cancelAction = this.cancelAction.bind(this);
    this.toggleModal = this.toggleModal.bind(this);

    this.state = {
      whichModal: ''
    };
  }

  componentDidMount () {
    const { iosWebView, scrollTopIOS } = this.props;

    if (iosWebView) {
      scrollTopIOS();
    }
  }

  toggleModal (whichModal) {
    this.setState({ whichModal });
  }

  cancelAction () {
    const bookingID = _.get(this.props, 'booking._id');
    this.context.router.push({ pathname: `/inbox/${bookingID}` });
  }

  render () {
    const {
      routeParams,
      accessToken,
      booking,
      pendingContracts,
      iosWebView,
      scrollTopIOS,
      bookingID,
      user
    } = this.props;

    const { whichModal } = this.state;
    const profileID = _.get(this.props, 'profile.SSOid') || user.SSOid;
    const reviewBookingID = _.get(routeParams, 'bookingID') || bookingID;
    // make sure only booking guest or host can see the review guest update form
    const bookingHostID = _.get(this.props, 'booking.host_id');
    const bookingHostView = bookingHostID === profileID;
    const bookingGuestID = _.get(this.props, 'booking.guest_id');
    const bookingGuestView = bookingGuestID === profileID;
    const viewAs = bookingHostView ? 'host' : 'guest';
    const priceBreakdown = priceBreakdownObject(pendingContracts);
    const locale = ('undefined' !== typeof navigator) ? navigator.language : '';

    if (bookingHostView || bookingGuestView) {
      return (
        <SharedIntlProviderHOC>
          <div className="ReviewBookingUpdateContainer ps-container-lg-margin ps-container-fixed">
            { (iosWebView && 'CurrentDetailsContainerModal' === whichModal) ?
              <div id="CurrentDetailsContainerModal">
                <CurrentDetailsContainer
                  booking={booking}
                  bookingId={booking._id}
                  accessToken={accessToken}
                  iosWebView={iosWebView}
                  scrollTopIOS={scrollTopIOS}
                  toggleModal={this.toggleModal}
                  whichModal={whichModal}
                />
              </div> :
              bookingHostView ?
                <ReviewGuestUpdateHV
                  {...this.props}
                  viewAs={viewAs}
                  controlId={reviewBookingID}
                  accessToken={accessToken}
                  cancelAction={this.cancelAction}
                  toggleModal={this.toggleModal}
                  whichModal={this.state.whichModal}
                /> :
                <ReviewGuestUpdateGV
                  {...this.props}
                  profileID={profileID}
                  priceBreakdown={priceBreakdown}
                  controlId={reviewBookingID}
                  accessToken={accessToken}
                  cancelAction={this.cancelAction}
                  toggleModal={this.toggleModal}
                  whichModal={this.state.whichModal}
                />
            }
          </div>
        </SharedIntlProviderHOC>
      );
    }

    window.location.href = '/inbox';
    return null;
  }
}

ReviewGuestUpdateMain.propTypes = {
  routeParams: PropTypes.object,
  accessToken: PropTypes.string,
  booking: PropTypes.object,
  currentContracts: normalizedContractsShape,
  pendingContracts: normalizedContractsShape,
  iosWebView: PropTypes.bool,
  scrollTopIOS: PropTypes.func,
  bookingID: PropTypes.string,
  user: PropTypes.object
};

ReviewGuestUpdateMain.contextTypes = {
  router: PropTypes.object
};
